import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import Routes from './routes'

import SeedTrackerTable from './SeedTrackerTable'
import SeedInventoryList from './SeedInventory/SeedInventoryList'
import SeedInventoryAdd from './SeedInventory/SeedInventoryAdd'

const SeedTrackerPage: React.FC = () => {
  return (
    <Switch>
      <Route path={Routes.List} exact={true}>
        <SeedTrackerTable />
      </Route>
      <Route path={Routes.SeedInventoryAdd} exact={true}>
        <SeedInventoryAdd />
      </Route>
      <Route path={Routes.SeedInventoryList} exact={true}>
        <SeedInventoryList />
      </Route>
      <Redirect to={Routes.List} />
    </Switch>
  )
}

export default SeedTrackerPage
